import React, { useState } from 'react';
import AdminPanel from './AdminPannel';

const ProductManager = () => {
  const [products, setProducts] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [editingProductId, setEditingProductId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    price: 0,
    category: '',
    description: '',
    isActive: true,
    imageUrl: '',
    stockQuantity: 0,
    sku: '',
    brand: '',
    model: '',
    dimensions: '',
    weight: '',
    material: '',
    color: '',
  });

  const handleInputChange = (e, fieldName) => {
    const value = fieldName === 'price' || fieldName === 'stockQuantity' ? parseFloat(e.target.value) :
                  fieldName === 'isActive' ? e.target.checked :
                  e.target.value;
    setFormData((prevData) => ({ ...prevData, [fieldName]: value }));
  };

  const handleAddProduct = () => {
    if (editingProductId) {
      setProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.id === editingProductId ? { ...product, ...formData } : product
        )
      );
      setEditingProductId(null);
    } else {
      setProducts((prevProducts) => [...prevProducts, { id: crypto.randomUUID(), ...formData }]);
    }
    setIsAdding(false);
    setFormData({
      name: '',
      price: 0,
      category: '',
      description: '',
      isActive: true,
      imageUrl: '',
      stockQuantity: 0,
      sku: '',
      brand: '',
      model: '',
      dimensions: '',
      weight: '',
      material: '',
      color: '',
    });
  };

  const handleEditProduct = (product) => {
    setEditingProductId(product.id);
    setFormData({ ...product });
    setIsAdding(true);
  };

  const handleDeleteProduct = (id) => {
    setProducts((prevProducts) => prevProducts.filter((product) => product.id !== id));
    if (editingProductId === id) {
      setEditingProductId(null);
      setIsAdding(false);
      setFormData({
        name: '',
        price: 0,
        category: '',
        description: '',
        isActive: true,
        imageUrl: '',
        stockQuantity: 0,
        sku: '',
        brand: '',
        model: '',
        dimensions: '',
        weight: '',
        material: '',
        color: '',
      });
    }
  };

  const handleCancelAdd = () => {
    setIsAdding(false);
    setEditingProductId(null);
    setFormData({
      name: '',
      price: 0,
      category: '',
      description: '',
      isActive: true,
      imageUrl: '',
      stockQuantity: 0,
      sku: '',
      brand: '',
      model: '',
      dimensions: '',
      weight: '',
      material: '',
      color: '',
    });
  };

  const iconStyle = { marginRight: '8px', height: '16px', width: '16px' };
  const buttonStyle = { fontWeight: 'bold', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', border: 'none', display: 'flex', alignItems: 'center' };
  const inputStyle = { marginTop: '4px', width: 'calc(100% - 16px)', padding: '8px', borderRadius: '4px', border: '1px solid #d1d5db' };
  const formContainerStyle = { marginBottom: '20px', padding: '15px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06)', border: '1px solid #e5e7eb' };
  const tableContainerStyle = { backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06)', border: '1px solid #e5e7eb', overflowX: 'auto' };
  const tableHeaderStyle = { padding: '10px 12px', textAlign: 'left', fontSize: '12px', fontWeight: 'medium', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.025em' };
  const tableCellStyle = { padding: '8px 12px', whiteSpace: 'nowrap', fontSize: '14px', color: '#374151' };
  const actionButtonStyle = { backgroundColor: 'transparent', border: '1px solid', padding: '5px 7px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center' };
  const responsiveFormGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' };
  const responsiveFormGroup = { marginBottom: '10px' };
  const responsiveTable = { width: '100%', borderCollapse: 'collapse' };
  const responsiveTableHeader = { ...tableHeaderStyle };
  const responsiveTableCell = { ...tableCellStyle };
  const responsiveActionsContainer = { display: 'flex', gap: '5px', justifyContent: 'flex-end' };
  const pageTitleStyle = { fontSize: '20px', fontWeight: 'bold', marginBottom: '15px', color: '#333' };
  const addNewButtonStyle = { ...buttonStyle, backgroundColor: '#3b82f6', color: '#fff', marginBottom: '15px' };
  const cancelButton = { ...buttonStyle, backgroundColor: '#e5e7eb', color: '#4b5563' };
  const submitButton = { ...buttonStyle, backgroundColor: '#4caf50', color: '#fff' };
  const formTitleStyle = { fontSize: '16px', fontWeight: 'semibold', marginBottom: '12px', color: '#333' };
  const labelStyle = { display: 'block', fontSize: '14px', fontWeight: 'medium', color: '#4b5563', marginBottom: '5px' };
  const textareaStyle = { ...inputStyle, minHeight: '80px' };
  const checkboxContainerStyle = { display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' };
  const checkboxToggleBase = { width: '30px', height: '16px', backgroundColor: '#e5e7eb', borderRadius: '8px', position: 'relative', cursor: 'pointer', transition: 'background-color 0.2s ease-in-out' };
  const checkboxToggleActive = { backgroundColor: '#3b82f6' };
  const checkboxSliderBase = { content: "''", position: 'absolute', width: '12px', height: '12px', backgroundColor: '#fff', borderRadius: '50%', top: '2px', left: '2px', transition: 'transform 0.2s ease-in-out' };
  const checkboxSliderActive = { transform: 'translateX(14px)' };
  const tableTitleStyle = { fontSize: '16px', fontWeight: 'semibold', marginBottom: '12px', padding: '10px', backgroundColor: '#f3f4f6', color: '#6b7280', borderBottom: '1px solid #e5e7eb' };
  const editButtonStyle = { ...actionButtonStyle, borderColor: '#3b82f6', color: '#3b82f6' };
  const deleteButtonStyle = { ...actionButtonStyle, borderColor: '#dc2626', color: '#dc2626' };
  const noProductsStyle = { textAlign: 'center', padding: '10px', color: '#718096' };

  return (
    <div style={{ display: 'flex' }}>
      <AdminPanel />
      <div style={{ marginLeft: 'auto', marginRight: 'auto', padding: '15px', backgroundColor: '#f9f9f9', width: 'calc(100% - 200px)' }}>
        <h1 style={pageTitleStyle}>Product Management</h1>

        {!isAdding && (
          <button
            onClick={() => setIsAdding(true)}
            style={addNewButtonStyle}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#2563eb')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#3b82f6')}
          >
            <span style={iconStyle}>+</span>
            Add New Product
          </button>
        )}

        {isAdding && (
          <div style={formContainerStyle}>
            <h2 style={formTitleStyle}>
              {editingProductId ? 'Edit Product' : 'Add New Product'}
            </h2>
            <div style={responsiveFormGrid}>
              <div style={responsiveFormGroup}>
                <label htmlFor="name" style={labelStyle}>Product Name</label>
                <input id="name" type="text" value={formData.name} onChange={(e) => handleInputChange(e, 'name')} style={inputStyle} placeholder="Enter product name" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="price" style={labelStyle}>Product Price</label>
                <input id="price" type="number" value={formData.price} onChange={(e) => handleInputChange(e, 'price')} style={inputStyle} placeholder="Enter product price" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="category" style={labelStyle}>Product Category</label>
                <select
                  value={formData.category}
                  onChange={(e) => handleInputChange(e, 'category')}
                  style={{ ...inputStyle, appearance: 'none', backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3csvg fill=\'%234a5568\' viewBox=\'0 0 20 20\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3cpath d=\'M10 12l-5-5 1.414-1.414L10 9.172l3.586-3.586L15 7l-5 5z\'/%3e%3c/svg%3e")', backgroundRepeat: 'no-repeat', backgroundPosition: 'right .5rem center', backgroundSize: '1em' }}
                >
                  <option value="">Select a category</option>
                  <option value="Electronics">Electronics</option>
                  <option value="Clothing">Clothing</option>
                  <option value="Books">Books</option>
                  <option value="Home Goods">Home Goods</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="description" style={labelStyle}>Product Description</label>
                <textarea id="description" value={formData.description} onChange={(e) => handleInputChange(e, 'description')} style={textareaStyle} placeholder="Enter product description" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="imageUrl" style={labelStyle}>Image URL</label>
                <input id="imageUrl" type="text" value={formData.imageUrl} onChange={(e) => handleInputChange(e, 'imageUrl')} style={inputStyle} placeholder="Enter image URL" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="stockQuantity" style={labelStyle}>Stock Quantity</label>
                <input id="stockQuantity" type="number" value={formData.stockQuantity} onChange={(e) => handleInputChange(e, 'stockQuantity')} style={inputStyle} placeholder="Enter stock quantity" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="sku" style={labelStyle}>SKU</label>
                <input id="sku" type="text" value={formData.sku} onChange={(e) => handleInputChange(e, 'sku')} style={inputStyle} placeholder="Enter SKU" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="brand" style={labelStyle}>Brand</label>
                <input id="brand" type="text" value={formData.brand} onChange={(e) => handleInputChange(e, 'brand')} style={inputStyle} placeholder="Enter brand" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="model" style={labelStyle}>Model</label>
                <input id="model" type="text" value={formData.model} onChange={(e) => handleInputChange(e, 'model')} style={inputStyle} placeholder="Enter model" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="dimensions" style={labelStyle}>Dimensions</label>
                <input id="dimensions" type="text" value={formData.dimensions} onChange={(e) => handleInputChange(e, 'dimensions')} style={inputStyle} placeholder="Enter dimensions" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="weight" style={labelStyle}>Weight</label>
                <input id="weight" type="text" value={formData.weight} onChange={(e) => handleInputChange(e, 'weight')} style={inputStyle} placeholder="Enter weight" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="material" style={labelStyle}>Material</label>
                <input id="material" type="text" value={formData.material} onChange={(e) => handleInputChange(e, 'material')} style={inputStyle} placeholder="Enter material" />
              </div>
              <div style={responsiveFormGroup}>
                <label htmlFor="color" style={labelStyle}>Color</label>
                <input id="color" type="text" value={formData.color} onChange={(e) => handleInputChange(e, 'color')} style={inputStyle} placeholder="Enter color" />
              </div>
              <div style={checkboxContainerStyle}>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" id="isActive" checked={formData.isActive} onChange={(e) => handleInputChange(e, 'isActive')} className="sr-only peer" />
                  <div style={{ ...checkboxToggleBase, ...(formData.isActive ? checkboxToggleActive : {}) }}>
                    <span style={{ ...checkboxSliderBase, ...(formData.isActive ? checkboxSliderActive : {}) }}></span>
                  </div>
                  <span className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">{formData.isActive ? 'Active' : 'Inactive'}</span>
                </label>
              </div>
            </div>
            <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={handleCancelAdd}
                style={cancelButton}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#d1d5db')}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#e5e7eb')}
              >
                <span style={iconStyle}>X</span>
                Cancel
              </button>
              <button
                onClick={handleAddProduct}
                style={submitButton}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#45a049')}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#4caf50')}
              >
                <span style={iconStyle}>💾</span>
                {editingProductId ? 'Update Product' : 'Add Product'}
              </button>
            </div>
          </div>
        )}

        <div style={tableContainerStyle}>
          <h2 style={tableTitleStyle}>Product List</h2>
          <div style={{ overflowX: 'auto' }}>
            <table style={responsiveTable}>
              <thead style={{ backgroundColor: '#f9fafb' }}>
                <tr>
                  <th style={responsiveTableHeader}>Product Name</th>
                  <th style={responsiveTableHeader}>Price</th>
                  <th style={responsiveTableHeader}>Category</th>
                  <th style={responsiveTableHeader}>Description</th>
                  <th style={responsiveTableHeader}>Image</th>
                  <th style={responsiveTableHeader}>Stock</th>
                  <th style={responsiveTableHeader}>SKU</th>
                  <th style={responsiveTableHeader}>Brand</th>
                  <th style={responsiveTableHeader}>Model</th>
                  <th style={responsiveTableHeader}>Dimensions</th>
                  <th style={responsiveTableHeader}>Weight</th>
                  <th style={responsiveTableHeader}>Material</th>
                  <th style={responsiveTableHeader}>Color</th>
                  <th style={responsiveTableHeader}>Active</th>
                  <th style={{ ...responsiveTableHeader, textAlign: 'right' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <td style={responsiveTableCell}>{product.name}</td>
                    <td style={responsiveTableCell}>${product.price.toFixed(2)}</td>
                    <td style={responsiveTableCell}>{product.category}</td><td style={responsiveTableCell}>{product.description}</td>
                    <td style={responsiveTableCell}>
                      {product.imageUrl && (
                        <img
                          src={product.imageUrl}
                          alt={product.name}
                          style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
                        />
                      )}
                    </td>
                    <td style={responsiveTableCell}>{product.stockQuantity}</td>
                    <td style={responsiveTableCell}>{product.sku}</td>
                    <td style={responsiveTableCell}>{product.brand}</td>
                    <td style={responsiveTableCell}>{product.model}</td>
                    <td style={responsiveTableCell}>{product.dimensions}</td>
                    <td style={responsiveTableCell}>{product.weight}</td>
                    <td style={responsiveTableCell}>{product.material}</td>
                    <td style={responsiveTableCell}>{product.color}</td>
                    <td style={responsiveTableCell}>{product.isActive ? 'Yes' : 'No'}</td>
                    <td style={{ ...responsiveTableCell, textAlign: 'right' }}>
                      <div style={responsiveActionsContainer}>
                        <button
                          onClick={() => handleEditProduct(product)}
                          style={editButtonStyle}
                          onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#eff6ff'; e.currentTarget.style.borderColor = '#2563eb'; e.currentTarget.style.color = '#2563eb'; }}
                          onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = '#3b82f6'; e.currentTarget.style.color = '#3b82f6'; }}
                        >
                          <span style={{ ...iconStyle, marginRight: '4px' }}>✏️</span>
                          <span style={{ fontWeight: 'bold' }}>Edit</span>
                        </button>
                        <button
                          onClick={() => handleDeleteProduct(product.id)}
                          style={deleteButtonStyle}
                          onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#fee2e2'; e.currentTarget.style.borderColor = '#b91c1c'; e.currentTarget.style.color = '#b91c1c'; }}
                          onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = '#dc2626'; e.currentTarget.style.color = '#dc2626'; }}
                        >
                          <span style={{ ...iconStyle, marginRight: '4px' }}>🗑️</span>
                          <span style={{ fontWeight: 'bold' }}>Delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {products.length === 0 && (
                  <tr>
                    <td colSpan="15" style={noProductsStyle}>No products added yet.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductManager;